module.exports = __webpack_public_path__ + "static/media/OspreyAI_Dark.a196884a.png";